import { createReducer, on } from '@ngrx/store';

import { AuthState } from '../../models/auth/auth.model';
import * as AuthActions from './auth.actions';

export const initialAuthState: AuthState = {
  authChecked: false
};

export const authReducer = createReducer(
  initialAuthState,

  on(AuthActions.rehydrationSuccess, (state, { user }) => ({
    ...state,
    authChecked: true,
    user,
    alert: undefined
  })),

  on(AuthActions.rehydrationFailed, (state) => ({
    ...state,
    authChecked: true,
    user: undefined
  })),

  on(AuthActions.updateUserProfile, (state, { user }) => ({
    ...state,
    user
  })),

  // Patches only the permission map: a refresh must never resurrect a user after logout,
  // nor overwrite profile fields it did not fetch.
  on(AuthActions.refreshPermissionsSuccess, (state, { permissions }) =>
    state.user ? { ...state, user: { ...state.user, permissions } } : state
  ),

  on(AuthActions.refreshUserPermissionsSuccess, (state, { userPermissions }) =>
    state.user ? { ...state, user: { ...state.user, userPermissions } } : state
  ),

  on(AuthActions.logout, () => initialAuthState)
);
